import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tabs, message, Tooltip  } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

import {
  getTypeOptions,
  getMedicalEquipmentList,
} from "../../actions/subscribe";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: '20px'
    },
    tabBox: {
      height: "40px",
      "& .ant-tabs-nav": {
        marginBottom: "0 !important",
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-tab-btn": {
        fontSize: "16px !important",
        fontWeight: "bold",
      },
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      "& .ant-table-cell": {
        wordBreak: "break-all !important",
      },
    },
    bold: {
      fontWeight: "bold",
    },
  };
};

class MedicalEquipment extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    allTypeList: [],
    firstCategoryList: [],
    secondCategoryList: [],
    data: [],
    tabIndex: 0,
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      deviceType: "",
      firstLevelCategory: "",
      secondLevelCategory: "",
      productDescription: "",
      expectedUse: "",
      productExamples: "",
      managementCategory: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      deviceType: '器械类型',
      firstLevelCategory: '一级产品分类',
      secondLevelCategory: '二级产品分类',
      productDescription: '产品描述',
      expectedUse: '预期用途',
      productExamples: '品名举例',
      managementCategory: '管理类别',
    },
    labelListObj: { 
      deviceType: 'allTypeList',
      firstLevelCategory: 'firstCategoryList',
      secondLevelCategory: 'secondCategoryList',
    },
    selectKeys: ['deviceType', 'firstLevelCategory' ,'secondLevelCategory'],
    dataType: [],
    sourceList: [],
    defaultOrder: "descend",
    page: {
      page: 1,
      pageSize: 10,
    },
    total: 0,
    scrollObj: {
      x: 1700,
      y: 600,
    },
    sortObj: {
      SortCriteria: "TrainingTimeKS",
      SortCriteriaMode: "Desc",
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  getTableHeight = () => {
    // 计算表格高度
    let height = window.innerHeight
    let lineHeight = document.getElementById('searchBar').offsetHeight
    this.setState({
      scrollObj: {
        x: 1700,
        y: height - lineHeight - 211
      }
    })
  }

  componentDidMount() {
   
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
    this.initParams()
    
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }
  }

  initParams = () => {
    let nameObj = {
      '01': '有源手术器械',
      '02': '无源手术器械',
      '03': '神经和心血管手术器械',
      '04': '骨科手术器械',
      '05': '放射治疗器械',
      '06': '医用成像器械',
      '07': '医用诊察和监护器械',
      '08': '呼吸、麻醉和急救器械',
      '09': '物理治疗器械',
      '10': '输血、透析和体外循环器械',
      '11': '医疗器械消毒灭菌器械',
      '12': '有源植入器械',
      '13': '无源植入器械',
      '14': '注输、护理和防护器械',
      '15': '患者承载器械',
      '16': '眼科器械',
      '17': '口腔科器械',
      '18': '妇产科、辅助生殖和避孕器械',
      '19': '医用康复器械',
      '20': '中医器械',
      '21':  '医用软件',
      '22': '临床检验器械'      
    }
    getTypeOptions().then(res => {
      let data = res.data
      let allList = []
      for(let firstKey in data) {
        let options = data[firstKey]
        let secondList = []
        for (let secondKey in options) {
          let childs = options[secondKey]
          secondList.push({
            value: secondKey,
            label: secondKey,
            children: childs.map(v => {
              return {
                value: v,
                label: v,
              }
            })
          })
        }
        let param = {
          value: firstKey,
          label: nameObj[firstKey],
          children: secondList
        }
        allList.push(param)
      }
      this.setState({
        allTypeList: allList
      })
    })
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        SourceOrganization: undefined,
        TrainingContent: "",
        TrainingTime: [],
        HowToAttend: "",
        WhetherToPay: undefined,
        WebUrl: "",
        Remarks: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'CreatedAt' || key == 'releaseDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.value == showValue
          }).label
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let param = Object.assign(
      {},
      this.state.form,
      this.state.page,
    );
    getMedicalEquipmentList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
          data: [],
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "器械类型",
        dataIndex: "DeviceTypeName",
        width: 160,
        key: "deviceType",
      },
      {
        title: "一级产品分类",
        dataIndex: "FirstLevelCategory",
        width: 160,
        key: "firstLevelCategory",
      },
      {
        title: "二级产品分类",
        dataIndex: "SecondLevelCategory",
        width: 180,
        key: "secondLevelCategory",
      },
      {
        title: "产品描述",
        width: 360,
        dataIndex: "ProductDescription",
        key: "productDescription",
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ProductDescription || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: "预期用途",
        dataIndex: "ExpectedUse",
        key: "expectedUse",
        width: 360,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ExpectedUse || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: "品名举例",
        dataIndex: "ProductExamples",
        key: "productExamples",
        width: 360,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.ProductExamples || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: "管理类别",
        dataIndex: "ManagementCategory",
        key: "managementCategory",
        width: 120,
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {};

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState(
      {
        filteredInfo: null,
        page: {
          page: 1,
          pageSize: 10,
        },
        form: {},
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };



  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.page &&
      pageSize == this.state.page.pageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          page: page,
          pageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  onChangeFirstSelect = (value, key) => {
    let form = {
      ...this.state.form,
      firstLevelCategory: undefined,
      secondLevelCategory: undefined
    }
    form[key] = value
    this.setState({
      form: form
    })
    // 获取一级分类列表数据
    if (!value) {
      this.setState({
        firstCategoryList: [],
        secondCategoryList: []
      })
    } else {
      let firstList = this.state.allTypeList.find(v => {
        return v.value == value
      }).children
      this.setState({
        firstCategoryList: firstList,
        secondCategoryList: []
      })
    }
  }

  onChangeSecondSelect = (value, key) => {
    let form = {
      ...this.state.form,
      secondLevelCategory: undefined
    }
    form[key] = value
    this.setState({
      form: form
    })
    // 获取二级分类列表数据
    if (!value) {
      this.setState({
        secondCategoryList: [],
      })
    } else {
      let secondList = this.state.firstCategoryList.find(v => {
        return v.value == value
      }).children
      this.setState({
        secondCategoryList: secondList,
      })
    }
  }

  checkData = () => {
    if (!this.state.form.deviceType) {
      message .warning('请先选择器械类型')
    }
  }

  checkFirstData = () => {
    if (!this.state.form.firstLevelCategory) {
      message .warning('请先选择一级产品分类')
    }
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">器械类型</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.deviceType}
                onChange={(e) => this.onChangeFirstSelect(e, 'deviceType')} 
              >
                {
                  this.state.allTypeList.map((v, i) => {
                    return (
                      <Option value={v.value} key={i}>{v.label}</Option>
                    )
                  })
                }
              </Select>
            </div>

            <div className="form-item">
              <div className="form-label">一级产品分类</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.firstLevelCategory}
                onClick={this.checkData}
                onChange={(e) => this.onChangeSecondSelect(e, 'firstLevelCategory')} 
              >
                {
                  this.state.firstCategoryList.map((v, i) => {
                    return (
                      <Option value={v.value} key={i}>{v.label}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">二级产品分类</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.secondLevelCategory}
                onClick={this.checkFirstData}
                onChange={(e) => this.onChangeForm(e, 'secondLevelCategory')} 
              >
                {
                  this.state.secondCategoryList.map((v, i) => {
                    return (
                      <Option value={v.value} key={i}>{v.label}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">产品描述</div>
              <Input  value={this.state.form.productDescription}
                onChange={(e) => this.onChangeForm(e.target.value, 'productDescription')} 
                placeholder="请输入产品描述"/>
            </div>
            <div className="form-item">
              <div className="form-label">预期用途</div>
              <Input  value={this.state.form.expectedUse}
                onChange={(e) => this.onChangeForm(e.target.value, 'expectedUse')} 
                placeholder="请输入预期用途"/>
            </div>
            <div className="form-item">
              <div className="form-label">品名举例</div>
              <Input  value={this.state.form.productExamples}
                onChange={(e) => this.onChangeForm(e.target.value, 'productExamples')} 
                placeholder="请输入品名举例"/>
            </div>
            <div className="form-item">
              <div className="form-label">管理类别</div>
              <Input  value={this.state.form.managementCategory}
                onChange={(e) => this.onChangeForm(e.target.value, 'managementCategory')} 
                placeholder="请输入管理类别"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search" id="searchBar">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">分类目录</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                scroll={this.state.scrollObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(MedicalEquipment));
